import CloseIcon from '../../../reusable/Icons/CloseIcon'

const MobMenuCloseIcon = ({ handler }) => {
  return <CloseIcon handler={handler} className="mob_menu_icon" />
}

export default MobMenuCloseIcon
